import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import AdminImageLoadingSpinner from '../Common/AdminImageLoadingSpinner.js';

const BoatGalleryImages = ({ galleryImages = [], onChange, errorIndexes = [] }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const inputRef = useRef(null);

  useEffect(() => {
    setImages(galleryImages);
    setLoading(false);
  }, [galleryImages]);

  const handleImageChange = (e) => {
    const newFiles = Array.from(e.target.files);
    const updatedImages = [...images, ...newFiles];
    setImages(updatedImages);
    if (onChange) onChange(updatedImages);
  };

  const handleRemoveImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
    if (onChange) onChange(updatedImages);
  };

  const renderImagePreview = (img) => {
    if (typeof img === 'string') {
      return img;
    } else if (img instanceof File) {
      return URL.createObjectURL(img);
    } else if (typeof img === 'object' && img.url) {
      return img.url;
    }
    return '';
  };

  const handleAddImageClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const existingImagesCount = images.filter(img => typeof img === 'object' && img.id).length;

  return (
    <div className="destination-gallery-container">
      {loading ? (
        <div className="loading-container">
          <AdminImageLoadingSpinner />
        </div>
      ) : (
        <>
          <h3>Gallery Images</h3>
          <div className="destination-gallery-images">
            {images.length > 0 ? (
              images.map((image, index) => {
                const isNewImage = !(typeof image === 'object' && image.id);
                let relativeNewIndex = index - existingImagesCount;
                const hasError = isNewImage && errorIndexes.includes(relativeNewIndex);

                return (
                  <div
                    key={index}
                    className={`destination-gallery-image ${hasError ? 'error-border' : ''}`}
                  >
                    <img src={renderImagePreview(image)} alt={`Gallery ${index + 1}`} />
                    <button
                      type="button"
                      className="remove-image-btn"
                      onClick={() => handleRemoveImage(index)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} size="lg" />
                    </button>
                  </div>
                );
              })
            ) : (
              <p>No images added yet.</p>
            )}
          </div>
          <input
            type="file"
            accept="image/*"
            multiple
            style={{ display: 'none' }}
            onChange={handleImageChange}
            ref={inputRef}
          />
          <button type="button" className="add-image-btn" onClick={handleAddImageClick}>Add Image</button>
        </>
      )}
    </div>
  );
};

export default BoatGalleryImages;